var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-auth"},[_c('main',{staticClass:"flex-fill"},[_c('div',{staticClass:"d-flex align-items-center"},[_vm._t("default")],2),_c('div',{staticClass:"side-img d-none d-md-block"})]),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }